import React, { useEffect, useState } from 'react';
import { Col, Row, Stack } from 'react-bootstrap';
import FormInput from "../../components/FormInput";
import ReactSelect from "../../components/ReactSelect";
import { HiMiniUsers } from 'react-icons/hi2';
import SvgIcons from "../../components/SVGIcons"
import { handleGetStates } from '../../services/state.service';
import { handleGetFinancialYears } from '../../services/financialyear.service';
const SearchForm = ({ filter, setFilter }) => {
    

    const customerLevelOptions = [
        { value: 'Pending', label: 'Pending' },
        { value: 'Accepted', label: 'Accepted' },
        { value: 'Rejected', label: 'Rejected' },
    ];

    const [stateOptions, setStateOptions] = useState([]);
    const [financialYearOptions, setFinancialYearOptions] = useState([]);

    useEffect(() => {
    
        // Fetch states
        handleGetStates().then(response => {
            setStateOptions(response.data.data.map(state => ({
                value: state.id,
                label: state.stateName,
            })));
        });
        // Get financial year list
        handleGetFinancialYears().then(response => {
            setFinancialYearOptions(response.data.data.map(fy => ({
                value: fy.id,
                label: fy.financialYear
            })));
        });
    }, []);

    return (
        <div className="theme-card-header px-1 header-search">
            <Stack
                gap={3}
                className="flex-wrap px-3 pt-3 align-items-start"
            >
                <h5 className="mb-0 position-relative fw-semibold fs-16">
                    <div className="align-items-center bg-black d-inline-flex custom-height-60 justify-content-center position-absolute rounded start-0 text-white theme-icon-box custom-width-60 z-1">
                    <span className='page-header-icon'>{SvgIcons.templateIcon}</span>
                    </div>
                    Data Review Listing
                </h5>
                <div className="w-100">
                    <Row className="g-3">
                        <Col md={2} className="d-flex">
                            <div className="custom-width-250 flex-grow-1 flex-md-grow-0">
                                <FormInput
                                    id="search"
                                    key={"search"}
                                    name="search"
                                    placeholder="Search"
                                    type="text"
                                    onChange={(event) => {
                                        if (event.target.value === "") {
                                            setFilter({
                                                ...filter,
                                                search: undefined,
                                            });
                                            return;
                                        }
                                        setFilter({
                                            ...filter,
                                            search: event.target.value,
                                        });
                                    }}
                                    value={filter.search}
                                />
                            </div>
                        </Col>
                        <Col md={10} className="d-flex justify-content-end">
                            <Row className="justify-content-end gx-2">
                                {/* <Col className="col-md-auto col-12 mb-3 mb-md-0">
                                    <ReactSelect
                                        id="district"
                                        key="district"
                                        name="district"
                                        label=""
                                        placeholder="All Districts"
                                        value={filter.district}
                                        options={districtOptions}
                                        onChange={(option) => {
                                            setFilter({
                                                ...filter,
                                                districtId: option ? option.target.value : '',
                                                district: option ? option.target.value : ''
                                            });
                                        }}
                                    
                                    />
                                </Col>
                                <Col className="col-md-auto col-12 mb-3 mb-md-0">
                                    <ReactSelect
                                        id="state"
                                        key="state"
                                        name="state"
                                        label=""
                                        placeholder="All States"
                                        value={filter.state}
                                        options={stateOptions}
                                        onChange={(option) => {
                                            setFilter({
                                                ...filter,
                                                stateId: option ? option.target.value : '',
                                                state: option ? option.target.value : '',
                                            });
                                        }}
                                    />
                                </Col>
                                <Col className="col-md-auto col-12 mb-3 mb-md-0">
                                    <ReactSelect
                                        id="customerLevel"
                                        key="customerLevel"
                                        name="customerLevel"
                                        label=""
                                        placeholder="Customer Level"
                                        value={filter.customerLevel}
                                        options={customerLevelOptions}
                                        onChange={(option) => {
                                            setFilter({
                                                ...filter,
                                                customerLevels: option ? option.target.value : '',
                                                customerLevel: option ? option.target.value : '',
                                            });
                                        }}
                                    />
                                </Col>
                                <Col className="col-md-auto col-12 mb-3 mb-md-0">
                                    <ReactSelect
                                        id="supplyTo"
                                        key="supplyTo"
                                        name="supplyTo"
                                        label=""
                                        placeholder="All Supply To"
                                        value={filter.supplyTo}
                                        options={supplyToOptions}
                                        onChange={(option) => {
                                            console.log("Supply",option);
                                            setFilter({
                                                ...filter,
                                                furtherSupplies: option ? option.target.value : '',
                                                supplyTo: option ? option.target.value : ''
                                            });
                                        }}
                                    />
                                </Col> */}
                                <Col className="col-md-auto col-12 mb-3 mb-md-0">
                                <ReactSelect
                                    label={""}
                                    id="financialYear"
                                    key="financialYear"
                                    name="financialYear"
                                    class="form-select "
                                    placeholder="All Financial Years"
                                    aria-label="Floating label select example"
                                    options={financialYearOptions}
                                    onChange={(e) => {
                                        setFilter({
                                            ...filter,
                                            financialYearId: e.target.value,
                                            financialYear: e.target.value ? e.target.value : ''
                                        });
                                    }}
                                    value={filter.financialYear}
                                />
                                </Col>
                                <Col className="col-md-auto col-12 mb-3 mb-md-0">
                                <ReactSelect
                                    label={""}
                                    id="state"
                                    key="state"
                                    name="state"
                                    class="form-select "
                                    placeholder="All State"
                                    aria-label="Floating label select example"
                                    options={stateOptions}
                                    onChange={(e) => {
                                        setFilter({
                                            ...filter,
                                            saleLocationId: e.target.value,
                                            state: e.target.value ? e.target.value : ''
                                        });
                                    }}
                                    value={filter.state}
                                />
                                </Col>

                                <Col className="col-md-auto col-12 mb-3 mb-md-0">
                                    <ReactSelect
                                        id="status"
                                        key="status"
                                        name="status"
                                        label=""
                                        placeholder="All Status"
                                        value={filter.status}
                                        options={customerLevelOptions}
                                        onChange={(option) => {
                                            setFilter({
                                                ...filter,
                                                status: option ? option.target.value : '',
                                            });
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        
                        
                    </Row>
                </div>
            </Stack>
        </div>
    );
};

export default SearchForm;
